import React, { useState } from 'react';
import developerImage from '../assets/images/devloper.png';
import hamburgerIcon from '../assets/images/ham.svg';
import closeIcon from '../assets/images/close.svg';

const About = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div>
      {/* Sidebar */}
      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          {/* Only show the close button when the sidebar is open */}
          {isSidebarOpen && (
            <img
              src={closeIcon}
              alt="Close Sidebar"
              className="close-btn"
              onClick={closeSidebar}
            />
          )}
        </div>
        <ul className="sidebar-links">
          <li><a href="/" onClick={closeSidebar}>Home</a></li>
          <li><a href="/about" onClick={closeSidebar}>About</a></li>
          <li><a href="/skills" onClick={closeSidebar}>Skills</a></li>
          <li><a href="/projects" onClick={closeSidebar}>Projects</a></li>
          <li><a href="/contact" onClick={closeSidebar}>Contact</a></li>
        </ul>
      </div>

      {/* Hamburger Menu - Show only when the sidebar is closed */}
      {!isSidebarOpen && (
        <img
          src={hamburgerIcon}
          alt="Open Sidebar"
          className="hamburger"
          onClick={toggleSidebar}
        />
      )}

      {/* Header */}
      <header>
        <nav className="navbar navbar-expand-lg">
          <div className="left">
            <a href="/" className="portfolio-link">
              <span className="purple">P</span>rem Portfolio
            </a>
          </div>

          <div className="right ml-auto">
            <ul className="navbar-nav">
              <li className="nav-item"><a className="nav-link" href="/about">About</a></li>
              <li className="nav-item"><a className="nav-link" href="/skills">Skills</a></li>
              <li className="nav-item"><a className="nav-link" href="/projects">Projects</a></li>
              <li className="nav-item"><a className="nav-link" href="/contact">Contact me</a></li>
            </ul>
          </div>
        </nav>
      </header>

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <section className="about-hero">
          <div className="hero-text">
            <h1>About Me</h1>
            <p className=''>
              Hello! I'm <span className="highlight">Prem</span>, a passionate web developer dedicated to creating elegant and efficient solutions.
            </p>
          </div>
          <div className="hero-image">
            <img src={developerImage} alt="developer" />
          </div>
        </section>

        {/* Biography Section */}
        <section className="biography">
          <h2>My Journey</h2>
          <p>
            I started my coding journey a few years ago, and since then, I've delved into numerous technologies and projects. My key focus areas are web development, backend technologies, and designing user-friendly interfaces.
          </p>
          <p>
            When I'm not coding, I love exploring new frameworks, learning about the latest industry trends, and gaming!
          </p>
        </section>

      </main>

      {/* Footer */}
      <footer>
        <div className="footer">
          <div className="footer-section">
            <h3>Prem's Portfolio</h3>
            <p>Building innovative solutions for the web, one project at a time.</p>
          </div>
          <div className="footer-section">
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About</a></li>
              <li><a href="/projects">Projects</a></li>
              <li><a href="/contact">Contact me</a></li>
            </ul>
          </div>
          <div className="third">
            <h4>Connect with me:</h4>
            <ul>
              <li>
                <a href="https://github.com/itachiuchiha241" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-github"></i> GitHub
                </a>
              </li>
              <li>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-linkedin"></i> LinkedIn
                </a>
              </li>
              <li>
                <a href="mailto:prempawar241@gmail.com">
                  <i className="fas fa-envelope"></i> Email Me
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-rights">
          <p className="mb-0">&copy; 2025 Prem's Portfolio. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default About;
